// Same-origin fetch() calls carry the Rails CSRF token.
//
// The /api endpoints now require a signed-in user. These pages authenticate
// with the Devise session cookie, and Api::V1::ApiController only accepts a
// session on a non-GET request when X-CSRF-Token matches (JSON requests to the
// other controllers need it too, or Rails drops the session). Most components
// call fetch() without that header, so it is added here once instead of in
// every call site. Cross-origin requests are left untouched.
(function () {
  if (typeof window === "undefined" || !window.fetch || window.fetch.__csrfPatched) return

  const originalFetch = window.fetch.bind(window)

  const csrfToken = () => {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : null
  }

  const isSameOrigin = (input) => {
    try {
      const url = typeof input === "string" ? input : input.url
      return new URL(url, window.location.href).origin === window.location.origin
    } catch (e) {
      return false
    }
  }

  const patchedFetch = (input, init = {}) => {
    const token = csrfToken()
    if (!token || !isSameOrigin(input)) return originalFetch(input, init)

    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined))
    // Some callers pass an empty token (e.g. a Redux store that never got it).
    const current = (headers.get("X-CSRF-Token") || "").trim()
    if (!current || current === "undefined" || current === "null") headers.set("X-CSRF-Token", token)
    return originalFetch(input, { ...init, headers, credentials: init.credentials || "same-origin" })
  }
  patchedFetch.__csrfPatched = true
  window.fetch = patchedFetch
})()
